import { useEffect, useState } from 'react';

import '../assets/css/drawer.css';
import '../assets/css/styles.css';
import logo from '../assets/img/logo.png';
import separador from '../assets/img/separador.png';
import env from '../env/env.js'
import mp from '../assets/img/ic_home/mp.png';
import fb from '../assets/img/ic_home/fb.png';
import ig from '../assets/img/ic_home/ig.png';
import tk from '../assets/img/ic_home/tk.png';
import bs from '../assets/img/ic_home/bs.png';
import { getCarrusel } from '../funciones/home.js';

import Drawer from '../components/drawer.jsx'
import Gallery from '../components/gallery.jsx'

//módulos de Swiper
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay, EffectFade } from 'swiper/modules';

//estilos de Swiper
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';
//import './CarruselPromos.css';

function Inicio(props) {
    const [promos, setPromos] = useState([]);
    useEffect(() => {

        const cargarDatos = async () => {
            try {
                const res = await fetch(env.getDomain() + 'escoba_getPromo');
                const data = await res.json();

                setPromos(data.promos);

            } catch (error) {
                console.error("Error al cargar las promociones:", error);
            } finally {
            }
        };

        cargarDatos();


    }, []);
    return (
        <div className="Sesion">
            <header>

            </header>


            <div class="" style={{ background: "#F0DCBD" }}>
                <div class="container-i">
                    <div class="logo center-v-">
                        <img src={logo} class="img-responsive ic-logo-xs" />
                    </div>

                    <div class="separador center-v-">
                        <img src={separador} class="img-responsive" />
                    </div>
                    <div class="buffer">
                        <p class="rage">¡Tus reseñas nos ayudan a volar más alto!</p>
                        <div class="center-v- top-buffer ">
                            <a href="https://maps.app.goo.gl/83vUHWZ4PZ18Kkm26" target='_blank'><img src={mp} class="img-responsive ic-redes" /></a>
                        </div>
                    </div>

                    <div class="separador center-v-">
                        <img src={separador} class="img-responsive" />
                    </div>
                    <div class="buffer">
                        <p class="rage">¡Síguenos  en nuestras redes sociales!</p>
                        <div class="row top-buffer ">
                            <div class="col center-v-">
                                <a href='https://www.facebook.com/la.escoba.encantada.2025' target='_blank'><img src={fb} class="img-responsive ic-redes" /></a>
                            </div>

                            <div class="col center-v-">
                                <a href='https://www.instagram.com/laescobaencantada/' target='_blank'><img src={ig} class="img-responsive ic-redes" /></a>
                            </div>

                            <div class="col center-v-">
                                <a href='https://www.tiktok.com/@laescobaencantada' target='_blank'><img src={tk} class="img-responsive ic-redes" /></a>
                            </div>

                            <div class="col center-v-">
                                <a href='https://wa.me/5215548067153' target='_blank'><img src={bs} class="img-responsive ic-redes" /></a>
                            </div>

                        </div>
                    </div>
                    <div class="separador center-v-">
                        <img src={separador} class="img-responsive" />
                    </div>
                </div>
                <Swiper
                    modules={[Navigation, Pagination, Autoplay, EffectFade]}
                    spaceBetween={20}
                    slidesPerView={1}
                    navigation
                    pagination={{ clickable: false }}
                    autoplay={{ delay: 10000, disableOnInteraction: false }}
                    loop={promos.length > 1}
                    breakpoints={{
                        // Responsivo: muestra más tarjetas en pantallas grandes
                        640: { slidesPerView: 1 },
                        768: { slidesPerView: 2 },
                        1024: { slidesPerView: 3 },
                    }}
                    className="mySwiper"
                >
                    {promos.map((item) => (
                        <SwiperSlide key={item.id}>
                            <div className="card-promo">
                                <div className="card-image-wrapper">
                                    <img class="img-responsive" src={item.imagen} alt={item.titulo} />
                                </div>
                                <div className="card-content">
                                    <h3>{item.titulo}</h3>
                                    <p>{item.descripcion}</p>
                                    {item.link && (
                                        <a href={item.link} className="btn-promo">
                                            Ver detalle
                                        </a>
                                    )}
                                </div>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>


            </div>


        </div>);
}

export default Inicio;